export const parseRequiredJustificationOptions = (
  options?: string | null,
): Set<string> =>
  new Set(
    (options ?? "")
      .split(",")
      .map((option) => option.trim().toLowerCase())
      .filter(Boolean),
  );

export const alternativeRequiresJustification = (
  integrationId: string | null | undefined,
  nrOption: number,
  requiredJustificationOptions?: string | null,
  requiredJustificationLessThan?: number | null,
): boolean => {
  const options = parseRequiredJustificationOptions(
    requiredJustificationOptions,
  );

  return options.size > 0
    ? options.has((integrationId ?? "").trim().toLowerCase())
    : !!requiredJustificationLessThan &&
        nrOption <= requiredJustificationLessThan;
};
